import { useQuery } from '@tanstack/react-query'
import { LobsterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

type Input = {
  keyword: string
}

// ラベルマスタをキーワード検索で取得する
export const useQueryLabelMasterSearch = ({ keyword }: Input) => {
  // keywordが入力されていない場合は実行しない
  const enabled = keyword !== ''

  return useQuery({
    queryKey: queryKeys.labelMasterSearch(keyword),
    queryFn: async () => {
      const { labelInspections } = await baseClient
        .getApi(LobsterApi, true)
        .getLabelInspectionsV2({ keyword })
        .catch(handleHTTPError)
      return labelInspections
    },
    enabled,
  })
}
